module.exports = __webpack_public_path__ + "static/media/video_aiPlato_new.1e225ffb.mp4";